import { createBitmapIcon } from './bitmap-icon';

export const ActionsRocks = createBitmapIcon(
    '/_n/images/fancy-landing/actions-rocks.svg'
);
